export function VideoTranscriptionUserPromptRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.VideoTranscriptionUserPrompt', {
		url: '/videoTranscriptionUserPrompt',
		controllerAs: 'vm',
		controller: VideoTranscriptionUserPromptCtrl,
		templateUrl: '/ng/hub/VideoTranscription/UserPrompt/VideoTranscriptionUserPromptCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'VideoTranscriptionUserPrompt page',
		},
	});
}

export class VideoTranscriptionUserPromptCtrl {
	constructor(modal) {
		'ngInject';
		this.modal = modal;
	}

	openLearnMore() {
		this.modal
			.state('hub.loggedin.VideoTranscriptionBetaConfirmation', {
				width: 681,
				height: 500,
				heading: 'Video Transcription Beta',
			})
			.then(() => {})
			.catch(() => {});
	}
}
